export const maintenanceContact = {
  filterInfo: {
    filterList: [
      {
        label: '姓名',
        type: 'input',
        value: 'contacts',
      },
      {
        label: '手机号',
        type: 'input',
        value: 'mobile',
      },
      {
        label: '电子邮箱',
        type: 'input',
        value: 'email',
      },
      {
        label: '类型',
        type: 'select',
        value: 'businessDirection',
        list: 'businessDirectionList',
      },
      {
        label: '是否默认',
        type: 'select',
        value: 'contactType',
        list: 'contactTypeList',
      },
    ],
    count: 12,
    data: {
      contactType: null,
      businessDirection: null,
    },
    btnStyle: [{ text: '查询', type: 'primary' }, { text: '重置' }],
  },
  tableLabel: [
    { label: '姓名', param: 'contacts', align: 'center' },
    {
      label: '手机号',
      param: 'mobile',
      align: 'center',
    },
    { label: '电子邮箱', param: 'email', align: 'center', width: '150' },
    {
      label: '负责目录',
      param: 'productTypeContent',
      align: 'center',
      slot: 'productTypeContentSlot',
      width: '260',
    },
    {
      label: '负责客户',
      param: 'customerDesc',
      align: 'center',
      // slot: 'customerContentSlot',
      minWidth: '100',
      tooltip: true,
    },
    {
      label: '负责地区',
      param: 'salesAreaContentDesc',
      align: 'center',
      slot: 'salesAreaContentDescSlot',
      width: '260',
    },
    {
      label: '类型',
      param: 'businessDirection',
      align: 'center',
      // slot: 'businessDirectionSlot',
      render: (row) => {
        return row.businessDirection === '102'
          ? '销售联系人'
          : row.businessDirection === '110'
            ? '财务联系人'
            : '采购联系人';
      },
    },
    {
      label: '是否默认',
      param: 'contactType',
      align: 'center',
      slot: 'contactTypeSlot',
    },
    {
      label: '操作',
      param: 'options',
      align: 'center',
      slot: 'optionsSlot',
    },
  ],
  listTypeInfo: {
    businessDirectionList: [
      { name: '全部', id: null },
      { name: '销售联系人', id: '102' },
      { name: '财务联系人', id: '110' },
      { name: '采购联系人', id: '101' },
    ],
    contactTypeList: [
      { name: '全部', id: null },
      { name: '默认', id: '101' },
      { name: '非默认', id: '102' },
    ],
  },
  tableOption: {
    label: '操作',
    width: '200',
    fixed: 'right',
    permission: '0',
    options: [
      {
        label: '查看',
        type: 'text',
        methods: 'handleCheck',
        permission: '/ubm/role/queryRoleAuthority',
      },
    ],
  },
};

export const defaults = {};
